export default __webpack_public_path__ + "static/media/noa-18.6501e2ac.jpg";